import { createSelector } from '@reduxjs/toolkit'

import { selectMdfActivitiesState } from './selectMdfActivitiesState'

export const selectMdfActivitiesLoadedContext = createSelector(
  [selectMdfActivitiesState],
  (state) => state.loadedContext
)
